import { colors } from "../theme";

interface CTAProps {
  isDark: boolean;
  onOpenWaitlist: (presets?: {
    interest?: string[];
    betaTester?: boolean;
    contactMe?: boolean;
  }) => void;
}

export function CTA({ isDark, onOpenWaitlist }: CTAProps) {
  return (
    <section
      className="py-32 px-8 relative transition-colors duration-[2000ms]"
      style={{ backgroundColor: isDark ? colors.base02 : colors.base2 }}
    >
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <h2 className="text-4xl md:text-6xl font-semibold tracking-tight mb-6">
          Let's turn off{" "}
          <span
            className={isDark ? "text-gradient-dark" : "text-gradient-light"}
          >
            some lights
          </span>
        </h2>
        <p
          className="text-xl mb-12"
          style={{ color: isDark ? colors.base01 : colors.base1 }}
        >
          Better for your budget. Better for the grid. Better for everyone.
        </p>
        <button
          onClick={() => onOpenWaitlist({ betaTester: true })}
          className="px-10 py-5 rounded-full font-medium text-lg transition-all duration-300 hover:scale-105"
          style={{
            backgroundColor: colors.magenta,
            color: colors.base3,
            boxShadow: `0 4px 24px ${colors.magenta}40`,
          }}
        >
          Get early access
        </button>
      </div>
    </section>
  );
}
